import { RouteRecordRaw } from 'vue-router';

import { AppRouteNames, AppRoutes } from '@tallo/investor/navigation';

import PropertyOnboardingStages from './components/property-onboarding-stages.vue';
import Address from './components/steps/address.vue';
import Description from './components/steps/description.vue';
import Images from './components/steps/images.vue';
import LeaseConditions from './components/steps/lease-conditions.vue';
import LeaseTerms from './components/steps/lease-terms.vue';
import PetPolicy from './components/steps/pet-policy.vue';
import PropertyOnboardingAvailability from './components/steps/property-onboarding-availability.vue';
import PropertyType from './components/steps/property-type.vue';
import RenterRequirements from './components/steps/renter-requirements.vue';
import Specification from './components/steps/specification.vue';
import TourTypes from './components/steps/tour-types.vue';
import { PropertyOnboardingStage, PropertyOnboardingStep } from './configs/stages.enum';
import PropertyOnboarding from './property-onboarding.vue';
import { getPropertyOnboardingStepRouteName } from './utils/get-property-onboarding-step-route-name.util';

export const propertyOnboardingRoutes: RouteRecordRaw = {
  name: AppRouteNames.INVESTOR_PROPERTY_ONBOARDING,
  path: AppRoutes.INVESTOR_PROPERTY_ONBOARDING,
  component: PropertyOnboarding,
  meta: { public: false },
  children: [
    {
      path: '',
      name: AppRouteNames.INVESTOR_PROPERTY_ONBOARDING_OVERVIEW,
      component: PropertyOnboardingStages,
    },
    {
      path: PropertyOnboardingStage.BASIC_DETAILS,
      redirect: { name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.ADDRESS) },
      meta: {
        stageName: PropertyOnboardingStage.BASIC_DETAILS,
        icon: 'building',
        iconColor: 'blue',
        title: 'Tell us about your property',
      },
      children: [
        {
          path: PropertyOnboardingStep.ADDRESS,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.ADDRESS),
          meta: { stepName: PropertyOnboardingStep.ADDRESS },
          component: Address,
        },
        {
          path: PropertyOnboardingStep.PROPERTY_TYPE,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.PROPERTY_TYPE),
          meta: { stepName: PropertyOnboardingStep.PROPERTY_TYPE },
          component: PropertyType,
        },
        {
          path: PropertyOnboardingStep.SPECIFICATIONS,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.SPECIFICATIONS),
          meta: { stepName: PropertyOnboardingStep.SPECIFICATIONS },
          component: Specification,
        },
      ],
    },
    {
      path: PropertyOnboardingStage.ADDITIONAL_DETAILS,
      redirect: { name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.LEASE_CONDITIONS) },
      meta: {
        stageName: PropertyOnboardingStage.ADDITIONAL_DETAILS,
        icon: 'calendar',
        iconColor: 'green',
        title: 'Add details and requirements',
      },
      children: [
        {
          path: PropertyOnboardingStep.PET_POLICY,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.PET_POLICY),
          meta: { stepName: PropertyOnboardingStep.PET_POLICY },
          component: PetPolicy,
        },
        {
          path: PropertyOnboardingStep.LEASE_CONDITIONS,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.LEASE_CONDITIONS),
          meta: { stepName: PropertyOnboardingStep.LEASE_CONDITIONS },
          component: LeaseConditions,
        },
        {
          path: PropertyOnboardingStep.LEASE_TERMS,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.LEASE_TERMS),
          meta: { stepName: PropertyOnboardingStep.LEASE_TERMS },
          component: LeaseTerms,
        },
        {
          path: PropertyOnboardingStep.RENTER_REQUIREMENTS,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.RENTER_REQUIREMENTS),
          meta: { stepName: PropertyOnboardingStep.RENTER_REQUIREMENTS },
          component: RenterRequirements,
        },
      ],
    },
    {
      path: PropertyOnboardingStage.MARKETING_DETAILS,
      redirect: { name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.IMAGES) },
      meta: {
        stageName: PropertyOnboardingStage.MARKETING_DETAILS,
        icon: 'sparkle',
        iconColor: 'violet',
        title: 'Make your listing stand out',
      },
      children: [
        {
          path: PropertyOnboardingStep.IMAGES,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.IMAGES),
          meta: { stepName: PropertyOnboardingStep.IMAGES },
          component: Images,
        },
        {
          path: PropertyOnboardingStep.DESCRIPTION,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.DESCRIPTION),
          meta: { stepName: PropertyOnboardingStep.DESCRIPTION },
          component: Description,
        },
        {
          path: PropertyOnboardingStep.TOUR_TYPES,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.TOUR_TYPES),
          meta: { stepName: PropertyOnboardingStep.TOUR_TYPES },
          component: TourTypes,
        },
        {
          path: PropertyOnboardingStep.AVAILABILITY,
          name: getPropertyOnboardingStepRouteName(PropertyOnboardingStep.AVAILABILITY),
          meta: { stepName: PropertyOnboardingStep.AVAILABILITY },
          component: PropertyOnboardingAvailability,
        },
      ],
    },
  ],
};
